import { Component, Input } from '@angular/core';
import { CommonModule } from 'src/common/common.module';
import { Link } from 'src/common/models';



@Component({
  selector: 'app-nav-fragment',

  imports: [CommonModule],
  templateUrl: './nav-fragment.component.html',
  styleUrl: './nav-fragment.component.css'
})
export class NavFragmentComponent {
  @Input() items: Link[] = [];
  @Input() id: string = '';
  @Input() level: number = 1;
}
